var _rect, _rect2, _path, _rect3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg1Cinza(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 50,
    rx: 4,
    fill: "#ACACAC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9.75,
    width: 30.25,
    height: 30.25,
    rx: 2,
    fill: "#CDCDCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 14.7916C21.4621 14.7916 22.7445 15.3228 23.69 16.2683C24.6355 17.2138 25.1666 18.4962 25.1666 19.8333C25.1666 21.1704 24.6355 22.4528 23.69 23.3983C22.7445 24.3438 21.4621 24.875 20.125 24.875C18.7878 24.875 17.5055 24.3438 16.56 23.3983C15.6145 22.4528 15.0833 21.1704 15.0833 19.8333C15.0833 18.4962 15.6145 17.2138 16.56 16.2683C17.5055 15.3228 18.7878 14.7916 20.125 14.7916M20.125 27.3958C25.696 27.3958 30.2083 29.6519 30.2083 32.4375V34.9583H10.0416V32.4375C10.0416 29.6519 14.5539 27.3958 20.125 27.3958Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.25,
    y: 9.75,
    width: 30.25,
    height: 30.25,
    rx: 2,
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.375 14.7916C56.7121 14.7916 57.9945 15.3228 58.94 16.2683C59.8855 17.2138 60.4166 18.4962 60.4166 19.8333C60.4166 21.1704 59.8855 22.4528 58.94 23.3983C57.9945 24.3438 56.7121 24.875 55.375 24.875C54.0378 24.875 52.7555 24.3438 51.81 23.3983C50.8645 22.4528 50.3333 21.1704 50.3333 19.8333C50.3333 18.4962 50.8645 17.2138 51.81 16.2683C52.7555 15.3228 54.0378 14.7916 55.375 14.7916M55.375 27.3958C60.946 27.3958 65.4583 29.6519 65.4583 32.4375V34.9583H45.2916V32.4375C45.2916 29.6519 49.8039 27.3958 55.375 27.3958Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1Cinza);
export default __webpack_public_path__ + "static/media/img1cinza.2d64d2df8ae227596586e687f4cb6dfb.svg";
export { ForwardRef as ReactComponent };